
function discountMoney(list,allMoney,day,rentType){
  if(list === null || list === undefined || list.length === 0){return 0;}
  var list = rentType === 'day' || rentType === 'buy' ? list.filter(item => item.useType === 'COMMON') : list;
  if(list.length == 0){
    return 0;
  }
  list.forEach(item=>{
    item.sortMoney = getDiscountMoneySort(item,allMoney,day);
    console.log(item.sortMoney);
  });
  list.sort((a,b)=>{return b.sortMoney.money - a.sortMoney.money}); // 排序
  return list[0].sortMoney;
}


function getDiscountMoneySort(row,allMoney,day){
  if(row.startMoney !== 0 && allMoney < row.startMoney){
    return buildRet('c',0);
  }
  if(row.type !== '1'){ // 指定定金额
    if(row.useType === 'FIRST_FIX'){
      return buildRet('f',(allMoney/parseInt(day)) - row.money);
    }
    
    return buildRet('c',row.money);
  }
  var retType = 'c';
  if(row.useType == 'FIRST_MONTH'){
    allMoney = (allMoney/parseInt(day));
    retType = 'f';
  }
  var money = allMoney * ((100 - row.money)/100);
  if(money > row.maxMoney){
    money = row.maxMoney;
  }
  return buildRet(retType,money);
}

function buildRet(type,money){
  return {type:type,money:money};
}


export {
  discountMoney,getDiscountMoneySort
}